module.exports = "https://web-assets.ifttt.com/packs/media/docs/applets_listed-64586da7.png";